import PropTypes from 'prop-types'
import {JsonViewer} from '../../../../../../../common/JsonViewer.jsx'
import {HeaderTitle} from '../../../../../../../common/HeaderTitle.jsx'
import InputWiz from "../../../../../../../common/inputs/wizard/InputWiz.jsx";
import RadioWiz from "../../../../../../../common/inputs/wizard/RadioWiz.jsx";
import {optionsTakNie} from "../../../../../../../utils/options.js";
import {Alert, Col, Row} from "react-bootstrap";
import TextareaWiz from "../../../../../../../common/inputs/wizard/TextareaWiz.jsx";
import DateTimeWiz from "../../../../../../../common/inputs/wizard/DateTimeWiz.jsx";
import MultiSelectList from "../../../../../../../common/inputs/MultiSelectList.jsx";
import Validation from "../../../../../../../common/wizard/Validation.jsx";
import {useSelector} from "react-redux";
import {useEffect} from "react";

export const ZadaniaIT = (props) => {
    const wiz = props.wiz
    const form = wiz?.form || {}

    const userData = useSelector((state) => state.user)
    const loggedInUserProfilId = userData?.profilId
    const userType = userData?.role
    const userPath = userType === 'oper' ? '/oper' : ""

    // Profil id twórcy projektu
    const projectProfileSymbol = form.profile_symbol
    const effectiveIdentifier = userType === 'oper'
        ? projectProfileSymbol
        : loggedInUserProfilId

    const isEffectiveDepartment = typeof effectiveIdentifier === 'string' && effectiveIdentifier.startsWith('D');

    const determinedUnitType = isEffectiveDepartment
        ? 'departament'
        : 'jednostka_podlegla'

    const isITProject = form.czy_zadania_it === 'Tak'
    const isDepartmentView = isITProject && determinedUnitType === 'departament'
    const isUnitView = isITProject && determinedUnitType === 'jednostka_podlegla'

    const hasCiRealizationOpinion = isDepartmentView && form.ci_opinia_realizacja === 'Tak'

    const zakresIT = Array.isArray(form.zakres_it_list) ? form.zakres_it_list : [];
    const zakresITSprzet = zakresIT.some(item => item.slownik_zakres_it_nazwa === 'Sprzęt');
    const zakresITOprogramowanieLicencje = zakresIT.some(item =>
        item.slownik_zakres_it_nazwa === 'Oprogramowanie' ||
        item.slownik_zakres_it_nazwa === 'Licencje, abonamenty, plany'
    );

    const hasExternalManagement = isDepartmentView && form.czy_realizacja_it_firma_zewnetrzna === 'Tak' && zakresITOprogramowanieLicencje;
    const hasExternalMaintenance = isDepartmentView && form.czy_utrzymanie_it_firma_zewnetrzna === 'Tak' && zakresITSprzet;
    const requiresCiMaintenanceFields = hasExternalManagement || hasExternalMaintenance;
    const hasCiMaintenanceOpinion = requiresCiMaintenanceFields && form.ci_opinia_utrzymanie === 'Tak';

    const isWygaszenie = isUnitView && form.jednostka_wygaszenie === 'Tak';

    useEffect(() => {
        const currentRodzajJednostki = form.rodzaj_jednostki;

        if (isITProject) {
            if (currentRodzajJednostki !== determinedUnitType) {
                wiz.setValue('rodzaj_jednostki', determinedUnitType);
            }
        } else {
            if (currentRodzajJednostki !== undefined) {
                wiz.setValue('rodzaj_jednostki', undefined);
            }
        }
    }, [isITProject, determinedUnitType, form.rodzaj_jednostki, wiz]);

    return (
        <div>
            <JsonViewer src={wiz?.form || {}} show={false}/>

            <HeaderTitle noHr size={'fs-3'} title={'Zadania związane z IT'}/>
            <HeaderTitle
                noHr
                size={'fs-4'}
                title={'Wprowadź informację na temat zadań związanych z IT'}
            />

            <div className={'d-flex flex-column gap-3'}>
                <RadioWiz
                    wiz={wiz}
                    keyName={'czy_zadania_it'}
                    label={wiz?.getLabel('czy_zadania_it')}
                    options={optionsTakNie}
                />

                {isDepartmentView && (
                    <div className={'d-flex flex-column gap-3 border p-3 mt-3'}>
                        <RadioWiz
                            wiz={wiz}
                            keyName={'ci_opinia_realizacja'}
                            label={wiz?.getLabel('ci_opinia_realizacja')}
                            options={optionsTakNie}
                        />

                        {wiz?.form?.ci_opinia_realizacja === 'Tak' &&
                            <Alert className={'text-start fw-normal'} variant="info">
                                Wybierając odpowiedź 'Tak' należy w sekcji P. Załączniki dołączyć dokument dotyczący
                                opinii CI.
                            </Alert>}


                        {hasCiRealizationOpinion && (
                            <>
                                <Row>
                                    <Col>
                                        <DateTimeWiz
                                            hideTime
                                            wiz={wiz}
                                            keyName={'ci_data_opinii'}
                                        />
                                    </Col>
                                    <Col>
                                        <InputWiz
                                            wiz={wiz}
                                            keyName={'ci_numer_pisma'}
                                        />
                                    </Col>
                                </Row>

                                <Validation wiz={wiz} field={'zakres_it_list'}>
                                    <MultiSelectList
                                        endpoint={`${userPath}/slowniki`}
                                        dictName={'zakres_it'}
                                        queryId={'zakres_it_list'}
                                        label={wiz.getLabel('zakres_it_list')}
                                        displaySelectedFirst
                                        handleAllOptions
                                        addId
                                        onChange={(e) => {
                                            wiz.setValue("zakres_it_list", e?.map(el => ({
                                                slownik_zakres_it_id: el.value,
                                                slownik_zakres_it_nazwa: el.label
                                            })))
                                        }}
                                        value={wiz.form?.zakres_it_list?.map(el => ({
                                            value: el.slownik_zakres_it_id,
                                            label: el.slownik_zakres_it_nazwa
                                        }))}
                                    />
                                </Validation>

                                {zakresITOprogramowanieLicencje && (
                                    <div  className={'d-flex flex-column gap-3 mt-3'}>
                                        <RadioWiz
                                            wiz={wiz}
                                            keyName={'czy_realizacja_it_firma_zewnetrzna'}
                                            label={wiz?.getLabel('czy_realizacja_it_firma_zewnetrzna')}
                                            options={optionsTakNie}
                                        />

                                        <TextareaWiz
                                            wiz={wiz}
                                            keyName={'opis_oprogramowanie_it'}
                                        />
                                    </div>
                                )}
                                {zakresITSprzet && (
                                    <div  className={'d-flex flex-column gap-3'}>
                                        <RadioWiz
                                            wiz={wiz}
                                            keyName={'czy_utrzymanie_it_firma_zewnetrzna'}
                                            label={wiz?.getLabel('czy_utrzymanie_it_firma_zewnetrzna')}
                                            options={optionsTakNie}
                                        />

                                        <TextareaWiz
                                            wiz={wiz}
                                            keyName={'opis_sprzet_it'}
                                        />
                                    </div>
                                )}
                            </>
                        )}

                        {requiresCiMaintenanceFields && (
                                <RadioWiz
                                    wiz={wiz}
                                    keyName={'ci_opinia_utrzymanie'}
                                    label={wiz?.getLabel('ci_opinia_utrzymanie')}
                                    options={optionsTakNie}
                                />
                        )}

                        {hasCiMaintenanceOpinion && (
                            <div  className={'d-flex flex-column gap-3 mt-3'}>
                                <DateTimeWiz
                                    hideTime
                                    wiz={wiz}
                                    keyName={'ci_data_przekazania_utrzymania'}
                                />
                                <TextareaWiz
                                    wiz={wiz}
                                    keyName={'ci_plan_przekazania_utrzymania'}
                                />
                            </div>
                        )}

                        {requiresCiMaintenanceFields && (
                            <Validation wiz={wiz} field={'dostep_zewn_do_infr_it_urzedu'}>
                                <MultiSelectList
                                    endpoint={`${userPath}/slowniki`}
                                    dictName={'dostep_zewn_do_infr_it_urzedu'}
                                    queryId={'dostep_zewn_do_infr_it_urzedu'}
                                    label={wiz.getLabel('dostep_zewn_do_infr_it_urzedu')}
                                    displaySelectedFirst
                                    handleAllOptions
                                    addId
                                    onChange={(e) => {
                                        wiz.setValue("dostep_zewn_do_infr_it_urzedu", e?.map(el => ({
                                            slownik_dostep_zewn_it_id: el.value,
                                            slownik_dostep_zewn_it_nazwa: el.label
                                        })))
                                    }}
                                    value={wiz.form?.dostep_zewn_do_infr_it_urzedu?.map(el => ({
                                        value: el.slownik_dostep_zewn_it_id,
                                        label: el.slownik_dostep_zewn_it_nazwa
                                    }))}
                                />
                            </Validation>
                        )}

                        <TextareaWiz
                            wiz={wiz}
                            keyName={'wymagane_sla'}
                        />
                    </div>
                )}

                {isUnitView && (
                    <div className={'d-flex flex-column gap-3 border p-3 mt-3'}>

                        <Validation wiz={wiz} field={'jednostka_zakres_list'}>
                            <MultiSelectList
                                endpoint={`${userPath}/slowniki`}
                                dictName={'zakres_it'}
                                queryId={'jednostka_zakres_list'}
                                label={wiz.getLabel('jednostka_zakres_list')}
                                displaySelectedFirst
                                handleAllOptions
                                addId
                                onChange={(e) => {
                                    wiz.setValue("jednostka_zakres_list", e?.map(el => ({
                                        slownik_zakres_it_id: el.value,
                                        slownik_zakres_it_nazwa: el.label
                                    })))
                                }}
                                value={wiz.form?.jednostka_zakres_list?.map(el => ({
                                    value: el.slownik_zakres_it_id,
                                    label: el.slownik_zakres_it_nazwa
                                }))}
                            />
                        </Validation>

                        <TextareaWiz
                            wiz={wiz}
                            keyName={'jednostka_opis_zakresu'}
                        />

                        <RadioWiz
                            wiz={wiz}
                            keyName={'jednostka_wygaszenie'}
                            label={wiz?.getLabel('jednostka_wygaszenie')}
                            options={optionsTakNie}
                        />

                        <DateTimeWiz
                            hideTime
                            wiz={wiz}
                            keyName={'jednostka_data_zakonczenia'}
                        />

                        {!isWygaszenie && (
                            <TextareaWiz
                                wiz={wiz}
                                keyName={'jednostka_plan_po_trwalosci'}
                            />
                        )}
                    </div>
                )}
            </div>
        </div>
    )
}

ZadaniaIT.propTypes = {
    wiz: PropTypes.any,
}